import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, ArrowLeft } from "lucide-react";
import { toast } from "react-toastify";
import logo from "../assets/logo.svg";
import bgimg from "../assets/login_background_mage.svg";
import Logos_images from "../assets/Logos_background_images.svg";
import { APP_ROUTES } from "../constants/approutes";
import axios from "axios";
import { setHospitalDetails } from "../utils/hospitalStorage";
import soc_logo from "../assets/soc_logo.svg";
import isologo from "../assets/isologo.svg";
import HIPAAlogo from "../assets/HIPAAlogo.svg";
import ABDMlogosvg from "../assets/ABDMlogosvg.svg";
import ABDMPhrLogo from "../assets/ayu.svg";
import CMMILogo from "../assets/iccm.png";
import { startUserDetailsFetch } from "../utils/tokenManager";

import { encryptData } from "./utils/encryptData";

const Login = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [showOTP, setShowOTP] = useState(null);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [timer, setTimer] = useState(0);

  const phoneRegex = /^[6-9]\d{9}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleIdentifierChange = (value) => {
    if (/^\d+$/.test(value) && value.length > 10) return;
    setIdentifier(value);
    setError("");

    if (phoneRegex.test(value)) setShowOTP(true);
    else if (emailRegex.test(value)) setShowOTP(false);
    else setShowOTP(null);
  };

  const handleSendOTP = async () => {
    setError("");
    setIsSendingOTP(true);
    // Clear the OTP input when resending
    setOtp("");
    try {
      const response = await fetch(
        `${API_URL}auth/login-otp?mobileNumber=${identifier}`,
        {
          method: "POST",
          headers: { Accept: "application/json" },
        }
      );

      const result = await response.json();
      if (response.ok) {
        setIsOTPSent(true);
        setTimer(60);
        const countdown = setInterval(() => {
          setTimer((prevTimer) => {
            if (prevTimer <= 1) {
              clearInterval(countdown);
              return 0;
            }
            return prevTimer - 1;
          });
        }, 1000);
        toast.success("OTP sent successfully!");
      } else {
        const msg = result?.message || "Failed to send OTP.";
        setError(msg);
        toast.error(msg);
      }
    } catch (err) {
      console.error("Send OTP Error:", err);
      setError("Something went wrong while sending OTP.");
      toast.error("Something went wrong while sending OTP.");
    } finally {
      setIsSendingOTP(false);
    }
  };

  async function fetchNewAccessToken() {
    const refreshToken = localStorage.getItem("refresh_token");
    let jsonData = {
        userCode: process.env.REACT_APP_USER_CODE,
        passWord: process.env.REACT_APP_USER_PASSWORD,
        channel: 'M'
      };
    
      let encryptedPayload = encryptData(jsonData); 

    // const payload = {
    //   data: "YLpBA7MjcxWLpgb4m+CxWI6QKnB0NK0APRXasgcP64he68zrk+guYgOCWZOstXE6pWoImfRwdkHlpTysPq3jperkHHakoNiA05tpy5BKrIA=",
    // };
    const response = await fetch(
      `${process.env.REACT_APP_API_URL_PATIENTS}gcp/oauth/token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${refreshToken}`,
        },
        body: JSON.stringify(encryptedPayload),
      }
    );

    const result = await response.json();
    localStorage.setItem("access_token", result.access_token);
  }
  async function fetchNewAccessTokenche() {
    try {
      const refreshToken = localStorage.getItem("refresh_token");
      const jsonData = {
        userCode: process.env.REACT_APP_USER_CODE,
        passWord: process.env.REACT_APP_USER_PASSWORD,
        channel: "M",
      };
      const encryptedPayload = encryptData(jsonData);
      const cheBaseUrl = process.env.REACT_APP_API_URL_CHE || "";

      const response = await fetch(`${cheBaseUrl}gcp/oauth/token`, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        
        },
        body: JSON.stringify(encryptedPayload),
      });

      const result = await response.json();
      console.log(result, "resultjhbjk");
      if (!response.ok) {
        console.error("CHE token fetch failed:", result);
        return;
      }

      if (result.access_token) {
        localStorage.setItem("access_token_che", result.access_token);
      }
    } catch (error) {
      console.error("CHE token fetch error:", error);
    }
  }
  // async function fetchNewAccessToken(refreshToken) {
  //   const payload = {
  //     data: "YLpBA7MjcxWLpgb4m+CxWI6QKnB0NK0APRXasgcP64he68zrk+guYgOCWZOstXE6pWoImfRwdkHlpTysPq3jperkHHakoNiA05tpy5BKrIA=",
  //   };
  //   const response = await fetch(
  //     `${process.env.REACT_APP_API_URL_PATIENTS}gcp/oauth/token`,
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${refreshToken}`,
  //       },
  //       body: JSON.stringify(payload),
  //     }
  //   );

  //   const result = await response.json();
  //   localStorage.setItem("access_token", result.access_token);
  // }
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!identifier) {
      setError("Email or phone number is required.");
      toast.error("Email or phone number is required.");
      return;
    }

    if (showOTP === true) {
      if (!otp || otp.length < 4) {
        setError("Enter a valid OTP.");
        toast.error("Enter a valid OTP.");
        return;
      }
      setIsLoggingIn(true);
      try {
        const response = await fetch(
          `${API_URL}auth/verify-otp?mobileNumber=${identifier}&otp=${otp}`,
          {
            method: "POST",
            headers: { Accept: "*/*" },
          }
        );
        const data = await response.json();
        setIsLoggingIn(false);
        if (response.ok && data?.data?.token && data?.data?.active === true) {
          const allowedRoles = ["ADMIN", "USER", "SUPERADMIN", "FINANCE", "BUSINESS"];
          const roleSource = data?.data?.role ?? data?.data?.roles;
          const userRoles = Array.isArray(roleSource)
            ? roleSource
            : [roleSource];
          if (!userRoles.some((r) => allowedRoles.includes(r))) {
            const msg = "Access denied. Your role is not permitted to log in.";
            setError(msg);
            toast.error(msg);
            return;
          }
  fetchNewAccessToken();
  fetchNewAccessTokenche();
          // Rest of your login success handling
          document.cookie = `auth_token=${data.data.token}; path=/;`;
          localStorage.setItem("auth_token", data.data.token);
          localStorage.setItem("role", data.data.roles || data.data.role);
          localStorage.setItem("userId", data.data.userId);
          localStorage.setItem("refresh_token", data?.data?.refreshToken);
          localStorage.setItem("user", data?.data);
          localStorage.setItem("tenantId", data?.data?.tenantId);
          localStorage.setItem("categoryType", data?.data?.categoryType);
          localStorage.setItem("email", data?.data?.email || data?.data?.mobile + "@example.com");

          // await fetchNewAccessToken(data.data.refreshToken);
          toast.success("OTP verified. Welcome!");

          // Route based on role
          if (userRoles.includes("SUPERADMIN")) {
            navigate(APP_ROUTES.ADMIN_ONBOARDING);
          } else if (userRoles.includes("FINANCE")) {
            navigate(APP_ROUTES.CUREBAY_DOCTOR_LIST);
          } else if (userRoles.includes("ADMIN")) {
            const tid = data?.data?.tenantId?.trim?.() || "";
            navigate(tid === "CureBay" ? APP_ROUTES.CONSULTATION_LIST : APP_ROUTES.REPORTS);
          } else if (userRoles.includes("BUSINESS")) {
            navigate(APP_ROUTES.HOSPITAL_LIST);
          } else {
            navigate(APP_ROUTES.DASHBOARD);
          }
        }
        else if(response.ok && data?.data?.active === false)  {
          const msg = "Your account is inactive. Please contact the admin.";
          setError(msg);
          toast.error(msg);
        }
        else {
          const msg = data?.message || "Invalid OTP. Please try again.";
          setError(msg);
          toast.error(msg);
          // Reset timer and clear OTP when verification fails
          setTimer(0);
          setOtp("");
        }
      } catch (err) {
        console.error("OTP login error:", err);
        setError("Something went wrong during OTP login.");
        toast.error("Something went wrong during OTP login.");
      }
      return;
    }

    if (showOTP === false) {
      if (!password || password.length < 6) {
        setError("Password must be at least 6 characters.");
        toast.error("Password must be at least 6 characters.");
        return;
      }
      setIsLoggingIn(true);
      const payload = { userName: identifier, password };
      try {
        const response = await fetch(`${API_URL}auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        console.log(data, "wserdtyguhji");
        setIsLoggingIn(false);
        if (data.status === 200 && data?.data?.active === true) {
          const allowedRoles = ["ADMIN", "USER", "SUPERADMIN", "FINANCE", "BUSINESS"];
          const roleSource = data?.data?.role ?? data?.data?.roles;
          const userRoles = Array.isArray(roleSource)
            ? roleSource
            : [roleSource];
            console.log(userRoles, "userRoles");   
          if (!userRoles.some((r) => allowedRoles.includes(r))) {
            const msg = "Access denied. Your role is not permitted to log in.";
            setError(msg);
            toast.error(msg);
            return;
          }
  fetchNewAccessToken();
  fetchNewAccessTokenche();
          // Rest of your login success handling
          document.cookie = `auth_token=${data?.data?.token}; path=/;`;
          localStorage.setItem("auth_token", data?.data?.token);
          localStorage.setItem("role", data?.data?.roles || data?.data?.role);
          localStorage.setItem("mobile", data?.data?.mobile);
          localStorage.setItem("firstName", data?.data?.firstName);
          localStorage.setItem("lastName", data?.data?.lastName);
          localStorage.setItem("userId", data?.data?.userId);
          localStorage.setItem("refresh_token", data?.data?.refreshToken);
          localStorage.setItem("tenantId", data?.data?.tenantId);
          localStorage.setItem("email", data?.data?.email);
          // Load feature flags before fetching clinic details
          try {
            const featureResp = await axios.get(`${API_URL}feature-flags/${data?.data?.tenantId}`, {
              headers: { Authorization: `Bearer ${data?.data?.token}` }
            });
            const disabledFeatures = Array.isArray(featureResp?.data)
              ? featureResp.data.filter((f) => f?.status === false).map((f) => f?.serviceName)
              : [];
            localStorage.setItem("disabledFeatures", JSON.stringify(disabledFeatures));
          } catch (e) {
            console.warn("Failed to load feature flags", e);
          }
          const authHeaders = {
            Authorization: `Bearer ${data?.data?.token}`,
            tenantId: data?.data?.tenantId,
          };
          const isHospi360 = data?.data?.categoryType === "HOSPI360";
          localStorage.setItem(
            "categoryType",
            data?.data?.categoryType
          );
          const detailsUrl = isHospi360
            ? `${API_URL}hospital`
            : `${API_URL}clinicDetails`;

          let details = null;
          try {
            const detailsResponse = await axios.get(detailsUrl, { headers: authHeaders });
            details = detailsResponse?.data ?? null;
          } catch (detailsError) {
            if (detailsError?.response?.status !== 404) {
              console.warn("Failed to load organization details", detailsError);
            }
            details = null;
          }
          const hasOrganizationDetails = Boolean(
            details &&
              (details.name ||
                details.hospitalName ||
                details.clinicId ||
                details.hospitalId ||
                details.id ||
                details.userId ||
                details.address)
          );
          setHospitalDetails(details);
          localStorage.setItem("hospitalid", details?.hospitalId || "");
          localStorage.setItem("HospitaluserId", details?.userId || "");
          console.log(details, "fgvhbjnk");
          localStorage.setItem(
            "clinicId",
            details?.clinicId || details?.hospitalId || details?.id || ""
          );
          localStorage.setItem(
            "clinilogo",
            details?.hospitalLogoUrl ||
              details?.logourl ||
              details?.logoUrl ||
              details?.hospitalLogo ||
              ""
          );
          localStorage.setItem(
            "clinicname",
            details?.name ||
              details?.hospitalName ||
              details?.firstName ||
              ""
          );
          localStorage.setItem(
            "organizationOnboarded",
            hasOrganizationDetails ? "true" : "false"
          );
          // await fetchNewAccessToken(data.data.refreshToken);
          toast.success("Login successful!");
          const tid = data?.data?.tenantId?.trim?.() || "";
          // Route based on role
          if (userRoles.includes("SUPERADMIN")) {
            navigate(APP_ROUTES.ADMIN_ONBOARDING);
          } else if (userRoles.includes("FINANCE")) {
            navigate(APP_ROUTES.CUREBAY_DOCTOR_LIST);
          } else if (userRoles.includes("ADMIN")) {
            navigate(tid === "CureBay" ? APP_ROUTES.CONSULTATION_LIST : APP_ROUTES.REPORTS);
          } else if (userRoles.includes("BUSINESS")) {
            navigate(APP_ROUTES.HOSPITAL_LIST);
          } else {
            navigate(APP_ROUTES.DASHBOARD);
          }
        }
        else if(data.status === 200 && data?.data?.active === false) {
          const msg = "Your account is inactive. Please contact the admin.";
          setError(msg);
          toast.error(msg);
        }
        else {
          const msg =
            data?.message || "Login failed. Please check credentials.";
          setError(msg);
          toast.error(msg);
        }
      } catch (err) {
        // console.error("Login error:", err);
        setError("Something went wrong. Please try again.");
        toast.error("Something went wrong. Please try again.");
      }
      return;
    }

    setError("Enter a valid email or 10-digit mobile number.");
    toast.error("Enter a valid email or 10-digit mobile number.");
  };

  return (
    <div className="flex min-h-screen">
      {/* Back Button for Mobile */}
      <div className="fixed top-4 left-4 z-50 md:hidden">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all duration-200"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">Back</span>
        </button>
      </div>
      
      {/* Left Side */}
      <div className="relative w-1/2 hidden md:flex flex-col bg-cover bg-center overflow-hidden">
        {/* Background Image */}
        <img
          src={bgimg}
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />

        {/* Overlay Content */}
        <div className="relative z-10 flex flex-col h-full px-10">
          {/* Logo on top */}
          <div className="pt-40" style={{ justifyItems: "center" }}>
            <img src={logo} alt="Logo" className="w-50" />
          </div>

          {/* Centered Welcome Content */}
          <div className="flex-1 flex flex-col  items-center text-white text-center">
            <h2 className="text-4xl font-bold text-[#3BBA83] mb-4 mt-8">
              Welcome Back
            </h2>
            <p className="text-base max-w-sm">
              Sign in and step into the future of healthcare—your clinic, fully
              digitized.
            </p>
          </div>

          <div className="mt-auto pb-10">
            <div 
              className="rounded-2xl p-6"
              style={{ 
                backgroundColor: 'rgba(0, 102, 204, 0.1)',
                backdropFilter: 'blur(10px)'
              }}
            >
               <img
          src={Logos_images}
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
              <div className="text-center mb-6">
                <h3 className="text-white text-lg font- mb-2">
                  Recognized. Certified. Trusted.
                </h3>
                <div className="w-16 h-0.5 bg-gray-300 mx-auto"></div>
              </div>
              
              <div className="relative z-10 flex justify-center items-center gap-4">
                {[
                  { src: isologo, alt: "ISO Certified" },
                  { src: HIPAAlogo, alt: "HIPAA Secured" },
                  { src: ABDMlogosvg, alt: "ABDM Integrated: M1, M2, M3" },
                  { src: soc_logo, alt: "AICPA SOC" },
                  { src: ABDMPhrLogo, alt: "ABDM Integrated: PHR, Health Locker" },
                  { src: CMMILogo, alt: "CMMI ML3 Appraised" },
                ].map((badge) => (
                  <div
                    key={badge.alt}
                    className="flex flex-1 min-w-0 items-center justify-center"
                  >
                    <img
                      src={badge.src}
                      alt={badge.alt}
                      className="max-h-20 w-full object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side */}
      <div className="w-full md:w-1/2 flex justify-center items-center bg-white p-10">
        <div className="w-full max-w-md">
        <div className="w-full mb-8">
          <div 
            className="rounded-2xl py-1 text-center"
            style={{
              background: 'linear-gradient(to right, #004276, #004D77, #00BD7F)'
            }}
          >
            <p className="text-lg font-medium mb-0">
              <span style={{ color: '#81FFC8' }}>Apno ki Sehat</span>
              <span className="text-white">, Ab Smart Clinic ke Saath</span>
            </p>
          </div>
        </div>
        <h2 className="text-3xl font-bold text-blue-900 text-center">
            Login Account
          </h2>
          <p className="text-base text-[#6D6D6D] text-center mb-16 ">
          Log in to connect with patients, prescriptions, and reports—anytime, anywhere.
          </p>
          {/* <p className="text-sm text-gray-600 text-center mb-16 mt-6">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p> */}

          <form onSubmit={handleLogin} className="space-y-5">
            <div className="relative">
              <input
                type="text"
                placeholder="Enter Phone Number or Email"
                value={identifier}
                onChange={(e) => handleIdentifierChange(e.target.value)}
                required
                className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded focus:outline-none pr-28"
              />
              {showOTP === true && !isOTPSent && (
                <button
                  type="button"
                  onClick={handleSendOTP}
                  disabled={isSendingOTP}
                  className="absolute right-2 top-1/2 -translate-y-1/2 bg-blue-900 text-white text-xs px-3 py-1 rounded-full hover:bg-blue-800 transition"
                >
                  {isSendingOTP ? "Sending..." : "Send OTP"}
                </button>
              )}
            </div>

            {isOTPSent && showOTP === true && (
              <div className="relative">
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                  maxLength={6}
                  className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded focus:outline-none pr-28"
                />
                {timer > 0 ? (
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                    Resend in {timer}s
                  </span>
                ) : (
                  <button
                    type="button"
                    onClick={handleSendOTP}
                    disabled={isSendingOTP}
                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-blue-900 text-white text-xs px-3 py-1 rounded-full hover:bg-blue-800 transition"
                  >
                    {isSendingOTP ? "Sending..." : "Resend OTP"}
                  </button>
                )}
              </div>
            )}

            {showOTP === false && (
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded focus:outline-none pr-10"
                />
                <div
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </div>
              </div>
            )}

            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}

            <button
              type="submit"
              disabled={isLoggingIn}
              className="w-full bg-blue-900 text-white py-2 mt-6 rounded-full hover:bg-blue-800 transition"
            >
              {isLoggingIn ? "Loading..." : "Login"}
            </button>
            {/* <p className="text-center text-sm mt-4">
              Don't have an account?{" "}
              <span
                onClick={() => navigate("/signup")}
                className="text-green-600 font-medium cursor-pointer"
              >
                Sign
              </span>{" "}
              here
            </p> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
